import React from 'react';

const Line = () => (
  <svg className="Line" viewBox="0 0 100 1" xmlns="http://www.w3.org/2000/svg">
    <line x1="0" y1="0" x2="100" y2="0" stroke="white" strokeWidth="1.2" />
  </svg>
);

export default Line;
